import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=63730c22&scoped=true&"
import script from "./Round.vue?vue&type=script&lang=ts&"
export * from "./Round.vue?vue&type=script&lang=ts&"
import style0 from "./Round.vue?vue&type=style&index=0&id=63730c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63730c22",
  null
  
)

export default component.exports